import { CMSApiBase, CMSGroupMode, CMSImageBase, createCmsUrl } from './base';
import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';

interface DynamicMissionAddon {
  groups: string[];
  goal: number;
  progress: number;
}

export interface DynamicMission {
  [key: string]: {
    value: number;
    goal: number;
    progress: number;
    addons: DynamicMissionAddon[];
  };
}

export interface CMSGroupsConfig {
  groupsIncludeMode: CMSGroupMode;
  groupsInclude: string | null;
  groupsExcludeMode: CMSGroupMode;
  groupsExclude: string | null;
}

export interface MissionI extends CMSGroupsConfig {
  name: string;
  backendId?: string;
  description?: string;

  button1Text: string;
  button1Link: string;
  button2Text: string;
  button2Link: string;

  coinImage: CMSImageBase;
  prizeCp?: string;
  prizeFs?: string;

  realTimeProgress?: boolean;
}

export interface MissionBlockI extends CMSGroupsConfig {
  title: string;
  background: CMSImageBase;
  characters: CMSImageBase;
  missions: MissionI[];
  showVipLabel?: boolean;
  showGuestToggle?: boolean;
  onlyGuestAvailable?: boolean;
  identifier?: string;
}

export interface TermsLoyalty extends CMSGroupsConfig {
  id: number;
  title: string;
  description?: string;
  showGuestToggle?: boolean;
  onlyGuestAvailable?: boolean;
  identifier?: string;
}

export interface LoyaltyPageApi extends CMSApiBase {
  title: string;
  logo?: CMSImageBase;
  missionsBlocks?: MissionBlockI[];
  termsAndConditions: TermsLoyalty[];
}

export const getLoyaltyCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'loyalty',
    queryData: { populate: 'deep', ...getCMSLocale(lang) },
  });

export const fetchLoyaltyCMS = async (lang: string) => {
  const response = await fetcherCMS<LoyaltyPageApi>(getLoyaltyCMSUrl(lang));
  return { data: response };
};
